import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

import('./main.sass');

import i18n from '@/plugins/i18n'

import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/es')
require('moment-timezone')
Vue.use(VueMoment, {
  moment
})


import {dialogOnBackPressHandlers} from '@/mixins/dialogsMixins'
import {accountMixin} from '@/mixins/baseGlobalMixin'

Vue.mixin(dialogOnBackPressHandlers)
Vue.mixin(accountMixin)

import './utils/Filters'

import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

import { defineCustomElements } from '@ionic/pwa-elements/loader';
defineCustomElements(window);

import './registerServiceWorker'
import {Device} from "@/utils/Capacitor";

if (process.env.VUE_APP_ENV === 'production') {
  console.log = function () {};
}

// HANDLE ERROR TO DISCORD
const webhook = require("webhook-discord");
const StackTrace = require("stacktrace-js");

Vue.config.errorHandler = async (error, vm) => {
  console.error('errorHandler error',error)
  console.info('errorHandler vm',vm)

  let email = vm.currentUser && vm.currentUser.email || '(Sin Usuario)'
  let errorMessage = error.toString()
  let routeName = vm.$route.name
  let routeParams =  JSON.stringify(vm.$route.params)
  let platform = await Device.getPlatform()

  const stackTrace = await StackTrace.fromError(error)
  const discordWebhook = process.env.VUE_APP_DISCORD_WEBHOOK || null
  const productionMode = process.env.NODE_ENV === 'production'
  if(discordWebhook && productionMode) {
    let stackTraceString = ''
    stackTrace.forEach((stack,i) => {
      stackTraceString += `\n ${i+1}- File: ${stack.fileName.substr(10)}`
      stackTraceString += `\n    Function: ${stack.functionName}`
      stackTraceString += `\n    Line: ${stack.lineNumber} \n`
    })

    let nd = 'n/d'
    let moreInfo = nd
    if(routeName === 'coach.calendar') {
      let currentComponent = stackTrace[0].fileName.substr(10)
      moreInfo = `Estudiante: ${vm.student && vm.student.name || nd} \n`
      switch (currentComponent) {
        case '/src/components/common/routines/CopyRoutineDialog.vue':
          moreInfo += `Fecha a copiar: ${vm.selectDate && JSON.stringify(vm.selectDate) || nd} \n`
          moreInfo += `Ejercicio: ${vm.exercise && vm.exercise.name || nd} \n`
          if(vm.students && vm.students.length > 0) {
            moreInfo += `Estudiantes a copiar: ${JSON.stringify(vm.students).substr(0,700)} \n`
          }
          break;
        case '/src/components/coach/routines/AddExerciseDesktopDialog.vue':
          moreInfo += `Categoria: ${vm.category && vm.category.name || nd} \n`
          moreInfo += `Ejercicio: ${vm.exercise && vm.exercise.name || nd} \n`
          moreInfo += `Fecha: ${vm.date && vm.date.name || nd} \n`
          moreInfo += `Modo edicion: ${vm.editMode ? 'Si' : 'No'} \n`
          break;
      }
    }

    const Hook = new webhook.Webhook(discordWebhook)

    const msg = new webhook.MessageBuilder()
        .setName(vm.appName)
        .setColor('#ff5252')
        .addField('Email', email)
        .addField('Error', errorMessage)
        .addField('Ruta', routeName)
        .addField('Plataforma', platform)
        .addField('Parametros', routeParams)
        .addField('Mas informacion', moreInfo)
        .addField('Stacktrace', stackTraceString.substr(0,1024))

    await Hook.send(msg)
  }
};

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
